'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  border: 0;\n  border-bottom: ', ';\n  background-color: ', ';\n  cursor: ', ';\n'], ['\n  border: 0;\n  border-bottom: ', ';\n  background-color: ', ';\n  cursor: ', ';\n']);

exports.FieldsetHeader = FieldsetHeader;
exports.default = Fieldset;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

var _style = require('../../utils/style');

var _layout = require('../layout');

var _fieldLabel = require('../field-label');

var _fieldLabel2 = _interopRequireDefault(_fieldLabel);

var _text = require('../text');

var _text2 = _interopRequireDefault(_text);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FieldsetHeader(props) {
  var legend = props.legend,
      description = props.description,
      meta = props.meta;


  return React.createElement(
    _layout.Box,
    { marginTop: 20 },
    legend ? React.createElement(
      _fieldLabel2.default,
      null,
      legend,
      meta ? React.createElement(
        _text2.default,
        {
          size: 'extra-small',
          color: 'silver',
          marginLeft: 10,
          weight: 'normal',
          resetTransform: true,
          display: 'inline'
        },
        meta
      ) : null
    ) : null,
    description ? React.createElement(
      _text2.default,
      { color: 'navy600', multiline: true },
      description
    ) : null
  );
}

var StyledFieldset = /*#__PURE__*/(0, _reactEmotion2.default)(_layout.Box)(_templateObject, function (props) {
  return props.bordered ? '1px solid ' + props.theme.colors.grey300 : null;
}, function (props) {
  return props.inset ? '' + props.theme.colors.navy300 : null;
}, function (props) {
  return props.interactive ? 'pointer' : 'inherit';
});

function Fieldset(props) {
  var children = props.children,
      _props$inset = props.inset,
      inset = _props$inset === undefined ? false : _props$inset,
      legend = props.legend,
      description = props.description,
      onClick = props.onClick,
      legendMeta = props.legendMeta,
      name = props.name,
      className = props.className,
      _props$bordered = props.bordered,
      bordered = _props$bordered === undefined ? true : _props$bordered,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'legend', 'description', 'onClick', 'legendMeta', 'name', 'className', 'bordered']);


  return React.createElement(
    StyledFieldset,
    (0, _extends3.default)({
      className: className,
      bordered: bordered,
      component: 'fieldset',
      inset: inset,
      interactive: !!onClick,
      onClick: onClick,
      padding: [20, 50, 40, 50] // top -20 accounts forr vertical spacing
      , name: name
    }, (0, _style.pickStyles)(otherProps)),
    legend ? React.createElement(FieldsetHeader, {
      meta: legendMeta,
      legend: legend,
      description: description
    }) : null,
    children
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/fieldset/fieldset.js
// module id = 321
// module chunks = 114276838955818